import api from '../../shared/api.json';
import { createUrl } from './createUrl';

function _redirecUserToLogin(redirectUrl) {
    global.location.href = createUrl(
        `${api.user.login}?redirectUrl=${encodeURIComponent(redirectUrl)}`
    );
}

function _resolveAction(requestUrl) {
    if (requestUrl.includes('/unfollow')) {
        return 'unfollow';
    } else if (requestUrl.includes('/follow')) {
        return 'follow';
    }
}

/**
 * handles ajax errors that resolves in 401
 *
 * @return true if user was redirected
 */
export const handlePossibleAuthError = (error, res) => {
    // handle authentication errors ONLY
    if (res.status === 401) {
        const action = _resolveAction(res.url);

        let redirectUrl = `${global.location.href}`;
        if (action) {
            redirectUrl += `?action=${action}`;
        }

        _redirecUserToLogin(redirectUrl);

        return true;
    }
};
